/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {DefaultLayout} from '~/components/Layout/Default';
import {makeLocaleStaticProps} from 'web_core/utils/static_props';
export const getStaticProps = makeLocaleStaticProps;
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    ul: "ul",
    li: "li",
    strong: "strong",
    ol: "ol",
    a: "a"
  }, props.components);
  return _jsxs(DefaultLayout, {
    head: {
      title: `利用規約`,
      description: "サービスの利用にあたり同意していただく必要がある内容が示されています。必ずご確認ください。"
    },
    maxWidth: 1000,
    children: [_jsx("h1", {
      className: "fs-3",
      children: "利用規約"
    }), _jsxs("div", {
      className: "mathdown-colorful",
      children: [_jsx(_components.p, {
        children: "数学に特化した情報共有サービス Mathlog では、以下の通りに利用規約を定めます。この利用規約は、Mathlog の運営が提供する本サービスの利用に関する条件を、本サービスを利用する登録ユーザ（第 1 条で定義します）と運営の間で定めるものです。登録ユーザは、充分に理解し、その精神を尊重して、Mathlog を利用するものとします。"
      }), _jsx(_components.h2, {
        children: "第 1 条（用語の定義）"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "本サービス"
          }), "\n", _jsx("br", {}), "\n", "数学特化の情報共有サービス Mathlog で、 mathlog.info のドメインで提供される全てのサービスを指します。また、API\nや RSS フィードも本サービスに含まれるものとします。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "運営"
          }), "\n", _jsx("br", {}), "\n", "本サービスの運営を指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "本規約"
          }), "\n", _jsx("br", {}), "\n", "本サービスの利用に関する条件を、登録ユーザと運営との間で定める「Mathlog 利用規約」及び、コミュニティガイドラインを含む総称を指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "アカウント"
          }), "\n", _jsx("br", {}), "\n", "本サービスを登録ユーザとして利用するために必要な Mathlog のアカウントを指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "ユーザ"
          }), "\n", _jsx("br", {}), "\n", "本サービスを利用する者を指します（アカウント作成をしていない者も含む）。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "登録ユーザ"
          }), "\n", _jsx("br", {}), "\n", "運営が定める手続き（ユーザ名・メールアドレス・パスワードの設定及びメールアドレスの確認等）を済まして、アカウント作成が完了したユーザを指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "プレミアムユーザ"
          }), "\n", _jsx("br", {}), "\n", "登録ユーザのうち運営が提供するプレミアムプランを契約しているユーザを指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "ログイン"
          }), "\n", _jsx("br", {}), "\n", "登録ユーザが本人であることを確認するための認証行為を指します。メールアドレスとパスワードの入力や外部\nSNS による認証等で行います。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "ユーザ情報"
          }), "\n", _jsx("br", {}), "\n", "登録ユーザがアカウント作成の際に入力した内容及びログイン後に設定可能となる個人情報（位置情報や\nWeb サイトのリンク等）を指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "投稿内容"
          }), "\n", _jsx("br", {}), "\n", "本サービスを利用して登録ユーザが投稿した記事、コメント、ユーザ情報等のテキストデータ、数式、画像、動画・音声ファイルを含む、本サービス上に投稿・送信されたデータの総称を指します。"]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "外部サービス"
          }), "\n", _jsx("br", {}), "\n", "本サービスが連携している認証システムを有するサービスの総称を指します。現状は Twitter\nのみです。"]
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 2 条（適用範囲・利用規約の変更）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "本規約は、登録ユーザと運営の間における、本サービスの利用につき生じるすべての法律関係に適用されます。"
        }), "\n", _jsx(_components.li, {
          children: "本規約は、日本法に準拠して解釈されるものとします。"
        }), "\n", _jsx(_components.li, {
          children: "本規約のいずれかの条項が無効又は実施できないと判断された場合には、それらの条項の有効又は実施できる部分及び本規約の残りの条項は、引き続き有効かつ実施できるものとします。"
        }), "\n", _jsx(_components.li, {
          children: "本規約のいずれかの規定が管轄裁判所によって法律に違反していると判断された場合には、効力のあるその他の残りの条項をもって、運営の意向をできる限り反映するように解釈することとします。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザは、本サービスから生じる又はそれに関連するいかなる訴訟も、当該訴訟の原因が生じてから一年以内に開始されなければならないことに合意し、当該期間経過後は、そのような訴訟は、永久に提訴できないものとします。"
        }), "\n", _jsx(_components.li, {
          children: "本規約から生じる又は関連するいかなる訴訟又は訴訟手続きについては東京地方裁判所を第 1 審の専属管轄裁判所とします。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザがアカウントの登録を行った場合には、本規約に同意したものとみなします。"
        }), "\n", _jsxs(_components.li, {
          children: ["運営は、次の各号のいずれかに該当する場合、登録ユーザの承諾を得ることなく本規約の内容を変更（追加を含む）できるものとします。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "本規約の変更が、登録ユーザの一般の利益に適合するとき。"
            }), "\n", _jsx(_components.li, {
              children: "本規約の変更が、登録ユーザが本サービスのアカウント作成をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsx(_components.li, {
          children: "運営は、本規約の変更を行う場合、変更した規約の効力発生日より 1 週間前までに、本規約を変更すること及び、変更後の規約の内容及び効力発生日を、公式 Twitter 及びメインページにて通知します。"
        }), "\n", _jsx(_components.li, {
          children: "変更後の規約の効力発生日以降に登録ユーザが本サービスを利用した場合は、本規約の変更に同意したものとみなします。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 3 条（アカウント）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "アカウントを作成して登録ユーザとなることで、記事の投稿やコメントの送信及び返信等の本サービス上での情報公開をはじめ、ユーザのフォロー、タグのトレース、ブックマーク等の機能の利用が可能になります。"
        }), "\n", _jsx(_components.li, {
          children: "本サービスを登録ユーザとして利用する希望者は、アカウントを取得するものとします。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザは 1 人につき唯一のアカウントを保有できるものとします。ただし、別途運営が許可した場合は除きます。"
        }), "\n", _jsx(_components.li, {
          children: "アカウント及びアカウント作成の際に送信したメールアドレスやパスワードは、登録ユーザ本人専用のものであり、いかなる場合も法人又は個人に対して、譲渡・貸与することを禁止します。"
        }), "\n", _jsx(_components.li, {
          children: "アカウントを使用して行われた行為は、そのアカウントを保有している登録ユーザが行ったものとみなします。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 4 条（ユーザ情報の管理）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "登録ユーザは、自身のユーザ情報の管理を自己責任で行うこととします。"
        }), "\n", _jsxs(_components.li, {
          children: ["ユーザ情報は、正確かつ以下に該当しないものでなければなりません。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "暴力的な表現、反社会的な勢力を想起させるもの"
            }), "\n", _jsx(_components.li, {
              children: "性的な表現に該当し公序良俗に反する恐れがあるもの"
            }), "\n", _jsx(_components.li, {
              children: "第三者の著作権、肖像権、パブリシティ権等の権利を侵害するもの"
            }), "\n", _jsx(_components.li, {
              children: "本人の情報ではないもの"
            }), "\n", _jsx(_components.li, {
              children: "その他、上記各号に準じるもの及び違法なもの"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "登録ユーザは、自身のユーザ情報を常に最新かつ正確に保ち、変更が生じた場合は、運営の定める変更手続きを行うものとします。"
          })
        }), "\n", _jsxs(_components.li, {
          children: ["登録ユーザは、メールアドレスやパスワードが第三者に漏洩した場合、第三者に利用された場合又はこれらの恐れがある場合は、直ちに", _jsx(_components.a, {
            href: "https://twitter.com/MathlogOfficial",
            children: "公式 Twitter の DM"
          }), "で、運営に連絡するものとします。"]
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第５条（プライバシー）"
      }), _jsxs(_components.p, {
        children: ["運営は本サービスを提供するにあたり、必要最小限の情報をユーザから取得します。運営は", _jsx(_components.a, {
          href: "/terms/privacy",
          children: "プライバシーポリシー"
        }), "に従って、ユーザから取得した個人情報の保護に最大限の注意を払います。"]
      }), _jsx(_components.h2, {
        children: "第６条（投稿内容の取り扱い）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["登録ユーザは、自身が投稿した投稿内容に関する", _jsx(_components.strong, {
            children: "一切の権利（著作権・特許権・商標権・著作権等の知的財産権、個人情報を含むプライバシー権・肖像権・パブリシティ権等の諸権利、企業秘密、及びその他の財産権）及びライセンスについて保有するか保証"
          }), "するものとします。"]
        }), "\n", _jsxs(_components.li, {
          children: ["投稿内容に対して著作権法第 21 条から第 28 条までにおいて定義される", _jsx(_components.strong, {
            children: "著作権に関する権利は投稿した登録ユーザ又は第三者に留保"
          }), "されます。"]
        }), "\n", _jsxs(_components.li, {
          children: ["登録ユーザが自己の保有する投稿内容に関する著作権を第三者に譲渡する場合、第三者に本条の内容につき承諾させるものとし、", _jsx(_components.strong, {
            children: "第三者が承諾しない場合には、当該著作権を譲渡できない"
          }), "ものとします。"]
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザは、著作権法第 18 条から第 20 条までにおいて定められる著作者人格権（公表権、氏名表示権、同一性保持権）については、運営に対して行使せず、又はさせないものとします。"
        }), "\n", _jsxs(_components.li, {
          children: ["登録ユーザは、", _jsx(_components.strong, {
            children: "運営に対して無償で非独占的かつ世界的"
          }), "に以下に示す権利を全て許諾するものとします。この許諾はあくまでも運営に対して行うものであり、第三者に対するものではありません。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["投稿内容を本サービス上で", _jsx(_components.strong, {
                children: "商用・非商用問わず"
              }), "公衆送信する権利（送信化可能化権を含む）"]
            }), "\n", _jsx(_components.li, {
              children: "学術研究データとしての提供を行う権利"
            }), "\n", _jsx(_components.li, {
              children: "本サービスのプログラム（CSS や JavaScript 等を使って記述されたもの）を用いて、投稿内容にデザインの適用及び変更を行う権利（このプログラムは、ユーザの許諾なしで、運営が必要に応じてバージョンアップや仕様変更等により変更が行えるものとします）"
            }), "\n", _jsxs(_components.li, {
              children: ["投稿内容を運営もしくは本サービスのプログラムによって", _jsx(_components.strong, {
                children: "翻訳する権利"
              })]
            }), "\n", _jsx(_components.li, {
              children: "投稿内容にその付随情報（投稿内容の目次や投稿者のユーザ情報、投稿時間等）を追加する権利"
            }), "\n", _jsx(_components.li, {
              children: "投稿内容を表示する周辺に運営が必要と判断する情報（広告や関連情報、他の投稿内容等）を区別できる形で掲載する権利"
            }), "\n", _jsxs(_components.li, {
              children: ["本サービスの紹介・告知もしくは", _jsx(_components.strong, {
                children: "投稿内容の紹介・告知"
              }), "を目的として、投稿内容の複製・抜粋・要約のいずれかを行った上で、必要に応じて翻訳（自動翻訳も含む）を行い、公衆送信（媒体は任意）・伝達・口述・上映・配布する権利"]
            }), "\n", _jsx(_components.li, {
              children: "本サービスの管理・改善・保守を目的として、投稿内容を本サービスを提供するためのデータベース、バックアップ用のデータベース、運営又は提携先（共同開発者等）の管理するパソコン等に複製する権利（パソコンに複製するために非公開で共有する権利も含む）"
            }), "\n", _jsx(_components.li, {
              children: "本サービスの追加機能・改善を検討する段階において、提携先（共同開発者等）への説明や運営内の情報共有を主の目的として、投稿内容の複製・公衆送信・上映・口述・配布を行う権利"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["運営が第 5 項の権利を使って投稿内容を利用をする上で、", _jsx(_components.strong, {
            children: "投稿者の情報を記載するかしないかの裁量は運営にある"
          }), "ものとします。"]
        }), "\n", _jsxs(_components.li, {
          children: ["登録ユーザは 本サービスの他のユーザ （他の登録ユーザを含むがその限りではない）に対して、", _jsx(_components.strong, {
            children: "無償で非独占的かつ世界的"
          }), "に以下に示す権利を全て許諾するものとします。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "日本の著作権法で認められている方法で著作物を利用する権利（私的利用が目的の複製、編集及び翻訳、自分の著作物への引用、学校等の教育機関で複製、非営利の上演する等）"
            }), "\n", _jsx(_components.li, {
              children: "本サービス上の投稿内容のコメント欄（投稿内容に対して意見・感想・指摘等を行えるスペース）において、投稿内容を必要に応じて、要約・翻訳等の翻案を行い投稿する権利及び投稿内容を抜粋した上で独自の見解や感想等を追記して投稿する権利"
            }), "\n", _jsx(_components.li, {
              children: _jsx(_components.strong, {
                children: "投稿内容が無償である場合に翻案（要約や翻訳等であり複製は含まない）を行い、翻案後の内容を記載する前に、翻案前の投稿内容へのリンクを掲載し、参考文献として示した上で、本サービス上で投稿する権利（本サービス上以外での翻案後の内容の公衆送信を認めるものではない）"
              })
            }), "\n", _jsxs(_components.li, {
              children: ["投稿内容が無償である場合、", _jsx(_components.strong, {
                children: "投稿内容の紹介"
              }), "を目的として、以下に示す項目をすべて遵守した上で、投稿内容を要約・抜粋して、必要に応じて翻訳（自動翻訳も含む）を行い、公衆送信（媒体は任意）・伝達・口述・上映・配布する権利", "\n", _jsxs(_components.ol, {
                children: ["\n", _jsxs(_components.li, {
                  children: ["要約・抜粋する投稿内容は、紹介する上で", _jsx(_components.strong, {
                    children: "必要最低限のもの"
                  }), "であること（記事のタイトル・ユーザのプロフィール画像・ユーザ名・紹介の文脈に関連性が非常に強い文章・画像・数式等は必要最低限の情報に含まれる）"]
                }), "\n", _jsxs(_components.li, {
                  children: [_jsx(_components.strong, {
                    children: "投稿内容へのリンク及び投稿者の情報"
                  }), "を記載又は情報の受け取り手に伝わるように明示すること"]
                }), "\n", _jsx(_components.li, {
                  children: "名誉毀損、誹謗中傷、侮辱行為、詐欺、投稿者へのなりすまし、他者の業務妨害等の内容が紹介に含まれないこと"
                }), "\n"]
              }), "\n"]
            }), "\n", _jsxs(_components.li, {
              children: ["投稿内容が無償である場合、以下に示す項目をすべて遵守した上で、「本サービスが提供する PDF ダウンロード機能を用いて、ダウンロードした PDF もしくはその PDF を印刷した資料」（以下「資料」）の数ページもしくは全ページを", _jsx(_components.strong, {
                children: "特定多数（特定少数も含む）に配布及び再配布"
              }), "する権利（配布方法は配布する必要のある人のみが受け取れる方法であれば任意）", "\n", _jsxs(_components.ol, {
                children: ["\n", _jsxs(_components.li, {
                  children: ["資料を受け取る側と資料を渡す側の間で、資料を配布することを理由とする", _jsx(_components.strong, {
                    children: "金銭のやり取りがない"
                  }), "こと（イベントや公演等で資料のあるなしによって入場料が異なる、塾や家庭教師が資料を配布をすることを理由に金額を高く設定する等が違反となる）"]
                }), "\n", _jsxs(_components.li, {
                  children: [_jsx(_components.strong, {
                    children: "資料の最初のページに記載されている内容（著者の情報・資料の利用に関する注意事項等が記載されているページ）は必ず配布"
                  }), "すること（例外として、配布する者が責任を持って注意事項の周知を行っている場合は配布しなくても良い）"]
                }), "\n", _jsxs(_components.li, {
                  children: ["資料の一部を変更して配布もしくは再配布する場合は、", _jsx(_components.strong, {
                    children: "元の内容を残した上で、変更した箇所が明確"
                  }), "にすること（ただし、著者の情報・資料の利用に関する注意事項の変更は不可とする）"]
                }), "\n", _jsxs(_components.li, {
                  children: ["資料を配布もしくは再配布する", _jsx(_components.strong, {
                    children: "目的が教育的"
                  }), "（セミナーにおける利用・議論を深めるための配布・輪講における利用・参考資料しての提供等）であること"]
                }), "\n"]
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["第 5〜7 項では、投稿内容についての著作権を規定したが、本サービス上で本規約の範囲内で創作された投稿内容の", _jsx(_components.strong, {
            children: "二次創作物についても同様に規定"
          }), "する（ダウンロードされた資料の編集は、本サービス上での創作ではないため、この二次創作には当たらない）。"]
        }), "\n", _jsx(_components.li, {
          children: "本サービス上で投稿を行う際は、常に他者がどう受け止めるかを理解しなければなりません。"
        }), "\n", _jsx(_components.li, {
          children: "法律違反、規約違反、その他運営が必要と認めた場合には、投稿者の承諾を得ることなく、投稿内容の削除又は修正を行う場合があります。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 7 条（ユーザ間決済）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "本サービスでは、バッチを送る機能を利用して他のユーザを金銭的に支援できます。"
        }), "\n", _jsx(_components.li, {
          children: "本サービスは、決済およびクレジットカード情報の管理を Stripe に委託しています。決済者は、Stripe の利用規約に同意したものとみなします。"
        }), "\n", _jsxs(_components.li, {
          children: ["バッチを送る機能等でユーザから他のユーザへの支払いを行う際に、支払いをするユーザは支払い金額の一部を運営が手数料として差し引くことに同意したものとみなします。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "Stripe が徴収する手数料（決済手数料）：支払い額の 3.6%（小数点四捨五入）"
            }), "\n", _jsx(_components.li, {
              children: "運営が徴収する手数料（プラットフォーム利用料）：支払い額から決済手数料を除いた額の 12%（小数点四捨五入）"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsx(_components.li, {
          children: "ユーザ間の支払いでは、運営が一度支払い金額をお預かりし、運営はユーザから払い出し申請があった場合に、払い出し金額を Amazon ギフトカードや銀行振込等でお支払いします。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 8 条（払い出し）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "今月に払い出し可能な金額は、先月末までに売り上げた分です。"
        }), "\n", _jsx(_components.li, {
          children: "払い出しの申請の締切日は毎月 20 日です。"
        }), "\n", _jsx(_components.li, {
          children: "申請を行わない場合は、翌月に繰り越されます。"
        }), "\n", _jsx(_components.li, {
          children: "払い出し金額が 500 円未満の場合は払い出しの申請ができません。"
        }), "\n", _jsxs(_components.li, {
          children: ["本サービスには、2 種類の払い出し方法が存在します。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["アマゾンギフトカード(E メールタイプ)", _jsx("br", {}), "アマゾンギフトカード(E メールタイプ)で払い出しをする場合は、アカウントのメールアドレスへお送りします。"]
            }), "\n", _jsxs(_components.li, {
              children: ["銀行振込", "\n", _jsxs(_components.ol, {
                children: ["\n", _jsx(_components.li, {
                  children: "銀行振込で払い出しをする場合は、本サービス上で振込先の銀行口座情報（金融機関名、支店名、預金種別、口座番号、口座名義）を登録する必要があります。"
                }), "\n", _jsx(_components.li, {
                  children: "振込先には日本国内の銀行口座のみ指定可能であり、払い出し金額から振込手数料を徴収させていただきます。振込手数料は、払い出し額が 5 万円未満の場合は 1 回あたり 220 円、払い出し額が 5 万円以上の場合は 1 回あたり 440 円。"
                }), "\n"]
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n", _jsx(_components.li, {
          children: "売り上げた日から 180 日を経過したにもかかわらず、ユーザが運営所定の申請手続きを行わない場合、運営は当該ユーザのアカウントのメールアドレスに運営が代理受領している代金からプラットフォーム利用料を引いた残高全額相当額のアマゾンギフトカード(E メールタイプ)を送付する場合があります。"
        }), "\n", _jsx(_components.li, {
          children: "アマゾンギフトカード(E メールタイプ)送信時にユーザーがメールアドレスを更新してないことに起因する損害は補填しないものとします。"
        }), "\n", _jsx(_components.li, {
          children: "振込口座が異なった際の組み戻し金はユーザが補填するものとします。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 9 条（広告やアンケート）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "運営は、本サービス上において、運営の裁量に基づいて、本規約に従って 広告を掲載することができる ものとし、ユーザはこれを予め承諾するものとします。"
        }), "\n", _jsxs(_components.li, {
          children: ["運営は、運営又は第三者の提供する商品又はサービスに関する", _jsx(_components.strong, {
            children: "広告等の情報を E-mail で配信できる"
          }), "ものとします。"]
        }), "\n", _jsx(_components.li, {
          children: "運営はユーザに対して、E-mail を使用したアンケートを実施することができるものとします。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 10 条（定期購読）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["登録ユーザは、", _jsx(_components.a, {
            href: "/pricing",
            children: "本サイトのこちらのページ"
          }), "で運営が別途定めるプレミアムプランを、運営が定める利用料金を支払うことにより、本利用規約に従って契約できるものとします。プレミアムプランを契約したユーザは、", _jsx(_components.a, {
            href: "/pricing",
            children: "プレミアムサービス"
          }), "を利用することができます。"]
        }), "\n", _jsxs(_components.li, {
          children: ["プレミアムプランの料金の支払いはクレジットカードまたは指定された決済サービスを通じて行われます。料金体系に関する詳細は、", _jsx(_components.a, {
            href: "/pricing",
            children: "こちらのページの価格表"
          }), "を参照してください。"]
        }), "\n", _jsx(_components.li, {
          children: "プレミアムプランに無料体験期間が定められている場合は、登録ユーザは料金の支払いなしでプレミアムサービスを利用することができます。無料体験期間の終了後は、プレミアムプランの料金を支払うことにより、プレミアムサービスを引き続き利用することができます。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザは運営が定める手続きを行うことで、いつでもプレミアムプランを解約することができます。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザは運営が定める手続きを行うことで、いつでもプランを変更することができます。プラン変更時の料金は、変更後のプランの料金のお支払い時に自動で調整されます。"
        }), "\n", _jsxs(_components.li, {
          children: ["以下のいずれかに該当する場合、運営は、プレミアム会員に対するプレミアムサービスの利用を停止することができるものとし、運営が悪質であると判断した場合、代金の支払を拒否し、違約金として没収することがあります。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "運営が定めるプレミアムプランの料金が未払いの場合。"
            }), "\n", _jsx(_components.li, {
              children: "本利用規約に違反していると運営が判断した場合。"
            }), "\n", _jsx(_components.li, {
              children: "その他、運営がプレミアムサービスの提供に支障が生じると判断した場合。"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsx(_components.li, {
          children: "運営は、プレミアムサービスの内容を予告なく変更または中止することがあります。重要な変更の場合は、ユーザーに事前に通知します。"
        }), "\n", _jsx(_components.li, {
          children: "運営は、プレミアムプランの利用によって生じた直接的または間接的な損害に対して、責任を負いません。ただし、運営の故意または重大な過失による場合はこの限りではありません。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 11 条（禁止事項）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["ユーザは、本サービスを利用するに際し、以下のような法律違反行為を行ってはなりません。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "著作権、特許権等の知的財産権を侵害する行為"
            }), "\n", _jsx(_components.li, {
              children: "プライバシーを侵害する行為"
            }), "\n", _jsx(_components.li, {
              children: "名誉毀損行為、侮辱行為や他者の業務妨害となる行為"
            }), "\n", _jsx(_components.li, {
              children: "詐欺行為"
            }), "\n", _jsx(_components.li, {
              children: "無限連鎖講（ネズミ講）を開設し、又はこれを勧誘・運営する行為"
            }), "\n", _jsx(_components.li, {
              children: "不正アクセス行為の防止等に関する法律に違反する行為、電子計算機損壊等業務妨害罪（刑法第 234 条の 2）に該当する行為をはじめ、運営及び他人のコンピューターに対して不正な操作を行う行為"
            }), "\n", _jsx(_components.li, {
              children: "その他犯罪に関わる行為あるいは法令に違反する行為"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["ユーザは本サービスを利用するに際し、以下のような社会的に不適切な行為を行ってはなりません。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "犯罪予告、犯罪の指南等、犯罪を引き起こすおそれのある行為"
            }), "\n", _jsx(_components.li, {
              children: "人種、民族、信条、性別、社会的身分、居住場所、身体的特徴、病歴、教育、財産及び収入等を根拠にする差別的表現行為"
            }), "\n", _jsx(_components.li, {
              children: "倫理的に問題がある低俗、有害、下品な行為、他人に嫌悪感を与える内容の情報を開示する行為。ポルノ、売春、風俗営業、これらに関連する内容の情報を開示する行為"
            }), "\n", _jsx(_components.li, {
              children: "迷惑行為、嫌がらせ行為、誹謗中傷行為、正当な権利なく他者に精神的被害・経済的被害を与える行為"
            }), "\n", _jsx(_components.li, {
              children: "自分以外の個人や会社、団体を名乗ったり、権限なく特定の会社や団体の名称を使用したり、架空の個人や会社、団体を名乗ったり、事実がないにも関わらず他の人物や会社、団体と業務提携や協力関係があると偽ったりする行為"
            }), "\n", _jsx(_components.li, {
              children: "他者になりすましてサービスを利用したり、情報を改ざんする行為"
            }), "\n", _jsx(_components.li, {
              children: "その他、公序良俗に反するかあるいは社会的に不適切な行動と解される行為"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["ユーザは本サービスを利用するに際し、以下のような本サービス利用上不適切な行為を行ってはなりません。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "運営の許諾無く 1 人でアカウントを複数保有する行為"
            }), "\n", _jsx(_components.li, {
              children: "他人に不快感や誤解を与えるようなユーザ名を使用する行為、運営あるいは他人、一般的に知られている社名、団体名、商品名と誤解されるような同一あるいは類似のユーザ名を使用する行為"
            }), "\n", _jsx(_components.li, {
              children: "他人の個人情報を盗用、収集、蓄積、変更、利用する行為、自分の個人情報やユーザ情報を不正に操作し、変更する行為"
            }), "\n", _jsx(_components.li, {
              children: "本サービス内でのページデザイン変更により、運営が標準的に表示しているヘッダー、フッター、広告及び著作権表示を運営の許諾なく非公開にする行為"
            }), "\n", _jsx(_components.li, {
              children: "運営の承諾無く本サービスを転用・売却・再販する行為"
            }), "\n", _jsx(_components.li, {
              children: "他者の著作権や機密情報、その他の権利を侵害する情報を掲載する行為"
            }), "\n"]
          }), "\n"]
        }), "\n", _jsx(_components.li, {
          children: "ユーザは以上の各項の他、運営が不適切であると判断する行為を行ってはなりません。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 12 条（登録ユーザの資格の取り消し）"
      }), _jsx(_components.p, {
        children: "以下のことが判明した場合は、運営の判断で、登録ユーザの資格を取消すことがあります。"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "ユーザ情報に虚偽があった場合"
        }), "\n", _jsx(_components.li, {
          children: "ユーザ情報に内容の変更が生じた際に、ユーザ情報の変更を行わなかった場合"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザが法律や本規約に違反した場合"
        }), "\n", _jsx(_components.li, {
          children: "ユーザ登録後一定期間本サービスを利用しなかった場合"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザが反社会的勢力等（暴力団、暴力団員、暴力団関係企業・団体又はその関係者、その他反社会的勢力これらに準じるものをいう）に該当する、又は資金提供その他の方法により反社会的勢力等に協力、又は関与していると運営が判断した場合"
        }), "\n", _jsx(_components.li, {
          children: "その他運営が不適切だと判断した場合"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 13 条（ユーザによる本サービスの終了）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "登録ユーザは、理由の如何を問わず、本サービスの利用を終了することができます。この場合において、登録ユーザは運営の定める手続き（アカウントの削除）を行うものとします。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザは、本規約の規定又は本規約の変更に対して異議がある場合又は本サービスの内容に異議がある場合でも、運営に対して講じることのできる手段は、本サービスの利用を終了することに限定されることを、あらかじめ了承します。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第 14 条（本サービスの変更・廃止）"
      }), _jsx(_components.p, {
        children: "運営は本サービスの内容を、ユーザへの事前の通知なくして変更することがありますが、ユーザは、それに同意するものとし、ユーザに不利益又は損害が発生したとしても、運営は一切その責任を負わないものとします。"
      }), _jsx(_components.h2, {
        children: "第 15 条（契約終了後の取扱い）"
      }), _jsx(_components.p, {
        children: "ユーザーが本サービスの利用を終了した場合及び運営が本サービスを廃止したことなど、何らかの理由によりユーザーが本サービスの利用資格を失った後においても、第６条は有効に存続し、ユーザーが登録したユーザー情報及び投稿内容を使用することができるものとします。"
      }), _jsx(_components.h2, {
        children: "第 16 条（免責事項）"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "本サービスを利用するためのあらゆる機器、ソフトウェア、通信手段はユーザご自身が各自の責任と費用において適切に準備、設置、操作していただく必要があります。運営はユーザのアクセス環境について一切関与せず、それらの準備、操作に関する責任を負いません。"
        }), "\n", _jsx(_components.li, {
          children: "運営より登録ユーザに対して連絡を行う際には、登録メールアドレスあての電子メールにて連絡を行います。登録ユーザは運営からの電子メールを受信できるよう登録メールアドレス情報を正しく維持するものとし、何らかの理由で受信ができなくなった場合には、登録ユーザは速やかに登録メールアドレスの変更を適切に行わなければなりません。運営からの電子メールが受信できなかったために登録ユーザが被った不利益については、ユーザ自身に責任があるものとし、運営は一切の責任を負いません。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザの作為又は不作為を原因として不正なメールアドレスやパスワードが使用された結果発生した損失、損害について、運営では一切責任を負わず、賠償しません。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザが外部サービスの ID 等を利用して本サービスに登録した場合、その ID 等の登録、利用については、外部サービスが規定する各規約の定めに従うものとし、運営はその内容について責任を負いません。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザが投稿したテキスト、数式、画像及び画像に付随する情報、個人情報や位置情報等に関する責任は、登録ユーザ各自にあります。従って、運営は登録ユーザが本サービスにおいて投稿した投稿容について、一切の責任を負いません。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザが他人の名誉を毀損した場合及び他人の権利（著作権・特許権・商標権・著作権等の知的財産権、個人情報を含むプライバシー権・肖像権・パブリシティ権等の諸権利、企業秘密、及びその他の財産権）を侵害した場合、当該ユーザは自身の責任と費用において解決しなければならず、運営は一切の責任を負いません。"
        }), "\n", _jsx(_components.li, {
          children: "登録ユーザの投稿内容が原因となって迷惑を受けたとする者が現れた場合には、当該登録ユーザは自身の責任と費用において解決しなければならず、運営は一切の責任を負いません。"
        }), "\n", _jsx(_components.li, {
          children: "運営は、ユーザが本サービス上又は運営から送信する E-mail 上から行った商品取引に対していかなる保証もいたしません。"
        }), "\n", _jsx(_components.li, {
          children: "ユーザは、ユーザの責任において本サービスを使用することに明示的に合意します。運営は、本サービスを「あるがままの状態で」かつ「適用可能な範囲」という条件で提供します。"
        }), "\n", _jsx(_components.li, {
          children: "運営は、取引の当事者ではなくユーザ間取引プラットフォームの提供者であり、本サービスに関して利用者と他の利用者または第三者との間において生じた取引、連絡または紛争等について、一切の責任を負いません。"
        }), "\n", _jsxs(_components.li, {
          children: ["運営は、以下の内容について一切の保証を行うものではありません。", "\n", _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "本サービスのサービス内容がユーザの要求に合致すること又は有益であること"
            }), "\n", _jsx(_components.li, {
              children: "本サービスにおいて他のユーザの投稿が正確又は適正であること"
            }), "\n", _jsx(_components.li, {
              children: "本サービスが中断、中止、廃止されないこと"
            }), "\n", _jsx(_components.li, {
              children: "本サービスがタイムリーに提供されること"
            }), "\n", _jsx(_components.li, {
              children: "本サービスが安全であること"
            }), "\n", _jsx(_components.li, {
              children: "本サービスにおいていかなるエラーも発生しないこと"
            }), "\n", _jsx(_components.li, {
              children: "ユーザが本サービスを通じて取得する情報が正確であること、合法的もしくは道徳的であること、最新であること、適切であること又は信頼できるものであること"
            }), "\n", _jsx(_components.li, {
              children: "本サービスにいかなる瑕疵もないこと"
            }), "\n", _jsx(_components.li, {
              children: "ユーザが本サービスを利用して行った行為がユーザの特定の目的商業的な目的を含みますがこれに限らない）に適合すること"
            }), "\n", _jsx(_components.li, {
              children: "本サービスを通じてユーザが登録するユーザ情報、又は投稿する投稿内容が消失しないこと"
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), _jsx("hr", {}), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "改定日：2024 年 1 月 7 日 プレミアム機能に関する内容を追加"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2023 年 5 月 18 日 一部機能の名前を変更"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2021 年 5 月 1 日 決済に関して追記"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2021 年 1 月 1 日"
        }), "\n", _jsx(_components.li, {
          children: "制定日：2020 年 11 月 6 日"
        }), "\n"]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
